// polyfills for IE
import 'core-js/fn/array/find';
import 'core-js/fn/symbol';
import 'core-js/fn/symbol/iterator';

import React from 'react';
import Mustache from 'mustache';

class Bookkeeper extends React.Component {
  constructor(props) {
    super();
    this.state = {
      variants: [],
      selected_variant: null,
      selected_rate: null,
      cart_url: props.cartUrl || null,
      loaded: false
    };

    var self = this;
    var initial = null;
    props.app.bind('OPTIONS_LOADED', function(data) {
      self.load(data);
      if (initial) {
        self.setVariant(initial);
        initial = null;
      }
    });
    props.app.bind('VARIANT_CHANGED', function(identity) {
      if (!self.state.loaded) {
        initial = identity;
      } else {
        self.setVariant(identity);
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.onUpdated && this.state.selected_variant) {
      this.props.onUpdated();
    }
  }

  load(data) {
    data.loaded = true;

    // initial cart_url overrides endpoint cart_url
    if (this.state.cart_url != null) {
      data.cart_url = this.state.cart_url;
    }

    this.setState(data);

    // apparently speeds up future processing
    Mustache.parse(this.state.cart_url);
  }

  setVariant(identity) {
    let variant = this.state.variants.find(v => v.id === identity);
    if (variant) {
      // if we currently have a selected_rate, find a matching rate on the incoming variant and use that
      let rate = null;
      if (this.state.selected_rate != null) {
        rate = variant.rates.find(r => r.id == this.state.selected_rate.id);
      }
      if (rate == null && variant.rates.length > 0) {
        rate = variant.rates[variant.rates.length - 1]; // choose the last rate (i.e. shortest period)
      }

      this.setState({
        selected_variant: variant,
        selected_rate: rate
      });
    }
  }

  handleChange(event) {
    let rate = null;
    if (this.state.selected_variant != null) {
      rate = this.state.selected_variant.rates.find(r => r.id == event.target.value);
    }

    this.setState({
      selected_rate: rate
    });
  }

  formatCurrency(value, places = 2, tryConvert = false) {
    if (typeof value !== 'number' && tryConvert) {
      try {
        value = parseFloat(value);
      } catch (_) {
        return value;
      }
    }
    if (typeof value === 'number') {
      value = parseFloat(value).toFixed(places <= 0 ? 1 : places).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      if (places <= 0)
        value = value.replace(/\.\d+$/g, '');
    }
    return value;
  }

  plural(number, singular="", plural="s") {
    if (number == 1) {
      return singular;
    } else {
      return plural;
    }
  }

  renderRate(rate) {
    let key = 'id_rates_' + rate.id;
    let freightFootnote = rate.freight != 0 && this.props.freightWording;

    return (
      <label key={rate.id} htmlFor={key} className="rate-label">
        <input id={key}
               type="radio"
               name="rates"
               value={rate.id}
               checked={this.state.selected_rate === rate}
               onChange={this.handleChange.bind(this)} />
        {rate.original && (
          <span className="rate-name rate-name-original">
            <span className="rate-price">${this.formatCurrency(rate.original.price, 0)}</span>
            <span className="rate-period">/{rate.original.period}</span>
          </span>
        )}
        <span className="rate-name">
          <span className="rate-price">${this.formatCurrency(rate.price, 0)}</span>
          <span className="rate-period">/ {rate.period}{freightFootnote ? ' *' : ''}</span>
        </span>
        <span className="rate-min-period">{rate.duration}</span>
      </label>
    );
  }

  render() {
    let cartHref = '#';
    let rates = [];
    let cartBtn = null;
    let purchase = null;
    let model = null;
    let priceGuide = null;
    let buyPricingBtn = null;
    let freightMessage = null;

    if (this.state.selected_variant != null) {
      if (this.state.selected_variant.model) {
        model = `Model: ${this.state.selected_variant.model}`;
      } else if (this.state.selected_rate) {
        model = this.state.selected_rate.duration;
      }

      if (this.state.cart_url != null) {
        cartHref = Mustache.render(this.state.cart_url, {
          variant: this.state.selected_variant,
          rate: this.state.selected_rate
        });
      }

      rates = this.state.selected_variant.rates.map(r => this.renderRate(r));

      let cartClass = "add-to-cart-btn btn btn-primary btn-lg " + this.state.selected_variant.type;
      cartBtn = (
        <a className={cartClass} href={cartHref}><i className="fa fa-shopping-cart" /> Add to Cart</a>
      )

      // if we have a selected rate that has buy pricing, create the DOM for it
      if (this.state.selected_rate) {
        if (this.state.selected_rate.freight > 0 && this.props.freightWording) {
          freightMessage = Mustache.render(this.props.freightWording, {
            freight: this.formatCurrency(this.state.selected_rate.freight, 2)
          });

          freightMessage = (
            <p className="freight">* {freightMessage}</p>
          );
        }

        if ((this.state.selected_rate.buy_pricing || []).length > 0) {
          let purchaseWording = this.props.purchaseWording || 'Apply to purchase pricing';
          buyPricingBtn = (
            <a href="#rate-details" className="pull-left collapsed" role="button" data-toggle="collapse"
               aria-expanded="false" aria-controls="rate-details">{purchaseWording} <i className="fa fa-chevron-down"/></a>
          );

          let price = this.state.selected_variant.sell_price;
          let valueNote = null;
          if (!!price) {
            valueNote = (
              <span>Rental agreement is based on an item value of ${this.formatCurrency(price, 0, true)}.<br/></span>
            );
          }

          priceGuide = (
            <p>{valueNote}
               Purchase request price guide for the selected
              ${this.formatCurrency(this.state.selected_rate.price, 0)}/{this.state.selected_rate.period} rate:
            </p>
          );

          let template = this.props.buyAtWording;
          if (template == null) {
            template = "At {{period}} pay no more than ${{price}}";
          }
          purchase = this.state.selected_rate.buy_pricing.map(p => {
            // p.period = 6
            // this.state.selected_rate.period = 'month'
            let sentence = Mustache.render(template, {
              period: p.period + " " + (p.period_name || this.state.selected_rate.period) + this.plural(p.period),
              price: this.formatCurrency(p.value, 0)
            });

            return (
              <li key={p.period}>{sentence}</li>
            );
          });
        }
      }
    }

    return (
        <div className={`bookkeeper rate-total-${rates.length}`}>
          <div className="rates">{rates}</div>
          {cartBtn}
          <div className="rate-preamble">
            <span className="pull-right">{model}</span>
            {buyPricingBtn}
          </div>
          <div className="rate-details collapse" id="rate-details">
            <div className="rate-details-inner">
              {priceGuide}
              <ul className="list-unstyled">
                {purchase}
              </ul>
              <p>While your contract is a rental contract, you can make us an offer to purchase at any time. Some price guides are set out above. For further price details at anytime during the rental period please contact us on 1300 858 911 (purchases are subject to approval and some conditions apply).</p>
            </div>
          </div>
          {freightMessage}
        </div>
    );
  }
}

export {
  Bookkeeper as default
}


// WEBPACK FOOTER //
// ./js/products/bookkeeper.jsx